import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import IconContactGrid from "../organisms/icon-contact-grid"
import { Grid, Block } from "../atoms/layout-primitives"
import { Text, T } from "../atoms/text"
import { css } from "styled-components"
import Button from "../atoms/button"

import VariantContainer from "../atoms/variant-container"

type TGridItem = {
  icon: JSX.Element
  title: string
}

interface IIconTitleGridContactPromo {
  title: string
  description: string
  gridItems: TGridItem[]
}

const IconTitleGridContactPromo = ({
  title,
  description,
  gridItems,
}: IIconTitleGridContactPromo) => {
  return (
    <>
      <VariantContainer
        variants={[
          { backgroundColor: "var(--tricorn-black)", padding: "64px 0" },
          null,
          { padding: "96px 0" },
        ]}
      >
        <Grid>
          {/* @ts-ignore */}
          <Text
            as="h2"
            variants={[
              css`
                ${T.sm.h2`500`}
                color: var(--light-background);
                grid-column: 1 / -1;
                text-align: center;
                margin-bottom: 24px;
              `,
              T.md.h2`500`,
              css`
                grid-column: 2 / 6;
                text-align: left;
                ${T.lg.h2`500`}
              `,
            ]}
          >
            {title}
          </Text>
          <Text.Body
            variants={[
              css`
                color: var(--light-background);
                grid-column: 1 / -1;
                text-align: center;
                margin-bottom: 48px;
              `,
              css`
                grid-column: 2 / -2;
                margin-bottom: 64px;
              `,
              css`
                text-align: left;
                grid-column: 2 / 6;
                margin-bottom: 0px;
              `,
            ]}
          >
            {description}
          </Text.Body>
          <IconContactGrid items={gridItems} />
          <Button.ScrollLink
            to="contact-form"
            smooth
            duration={1000}
            variants={{
              sm: {
                gridColumn: "2 / -2",
                justifySelf: "center",
                marginTop: "48px",
              },
              md: { gridColumn: "4 / -4" },
              lg: { gridColumn: "2 / 5", justifySelf: "left" },
            }}
          >
            Contact Us
          </Button.ScrollLink>
        </Grid>
      </VariantContainer>
    </>
  )
}

export default IconTitleGridContactPromo
